export default {
    data: function () {
        return {
            //
        }
    },
    methods: {
        maximizeElement: function () {
            if (this.data.locked === false) {
                let width = parseInt(this.$el.style.width.replace('px', '')),
                    height = parseInt(this.$el.style.height.replace('px', '')),
                    diffWidth = Math.abs(this.frame.width - width),
                    diffHeight = Math.abs(this.frame.height - height);

                let newWidth = 0
                let newHeight = 0

                if (diffWidth < 5 || diffHeight < 5) {
                    // Resize back
                    if (this.data.size.ratio === 0) {
                        newWidth = this.frame.default_size;
                        newHeight = this.frame.default_size ;
                    } else {
                        newWidth = this.frame.default_size;
                        newHeight = (this.frame.default_size * this.data.size.ratio);
                    }
                } else {
                    // maximize
                    if (this.data.size.ratio === 0) {
                        // ignore aspect ratio
                        newWidth = this.frame.width;
                        newHeight = this.frame.height;
                    } else {
                        // keep aspect ratio
                        if (height >= width) {
                            newWidth = (this.frame.height * (width / height));
                            newHeight = this.frame.height;
                        } else {
                            // test size
                            let testHeight = this.frame.width * this.data.size.ratio;

                            if (testHeight > this.frame.height) {
                                newHeight = this.frame.height;
                                newWidth = (this.frame.height * (width / height));
                            } else {
                                newWidth = this.frame.width;
                                newHeight = (this.frame.width * this.data.size.ratio);
                            }
                        }
                    }
                }
                this.$el.style.width = `${newWidth}px`
                this.$el.style.height = `${newHeight}px`

                this.$el.style.webkitTransform = this.$el.style.transform = 'translate(0,0)';
                this.$el.setAttribute('data-x', 0);
                this.$el.setAttribute('data-y', 0);
                this.tap();

                EaseEventBus.fire('elementMoved', {
                    id: this.index,
                    x: 0,
                    y: 0
                });
                this.$nextTick(() => {
                    EaseEventBus.fire('elementMovedEnd', {
                        id: this.index
                    });
                })

                const widthDom = parseInt(this.$el.style.width.replace('px', ''))
                const heightDom = parseInt(this.$el.style.height.replace('px', ''))

                EaseEventBus.fire('elementResized', {
                    id: this.index,
                    width:  Math.abs(widthDom - newWidth) >= 1 ? widthDom : newWidth,
                    height:  Math.abs(heightDom - newHeight) >= 1 ? heightDom : newHeight,
                });
                this.$nextTick(() => {
                    EaseEventBus.fire('elementResizedEnd', {
                        id: this.index
                    });
                })
            }
        }
    }
};
